import React, { useEffect, useState } from 'react';

import { Select } from '@vimeo/iris/components';

import { setLanguage, Locales } from '../setLanguage';
import DesktopFooter from './desktop/StandardFooter';
import MobileFooter from './mobile/StandardFooter';

interface Props {
  absoluteUrl?: boolean;
  locale: string;
  locales: Locales[];
  localeLabels: string[];
  xsrft: string;
  impressumQualifies?: boolean;
}

function StandardFooter({
  absoluteUrl = false,
  locale,
  locales = [],
  localeLabels = [],
  xsrft,
  impressumQualifies,
}: Props) {
  const [isDoNotSellReady, setIsDoNotSellReady] = useState(false);

  // The language select is shared between desktop and mobile views
  const languageSelect = locales && locales.length && (
    <Select
      id="language-select"
      size="sm"
      defaultValue={locale}
      onChange={(event: React.FormEvent<HTMLSelectElement>) => {
        const { value } = event.target as HTMLFormElement;

        setLanguage({ locale: value, token: xsrft }).then(
          ({ ok }: Response) => ok && window.location.reload(),
        );
      }}
    >
      {locales.map((locale, index) => (
        <Select.Option key={`${locale}-footer-${index}`} value={locale}>
          {localeLabels[index]}
        </Select.Option>
      ))}
    </Select>
  );

  useEffect(() => {
    window.onload = () => setIsDoNotSellReady(true);
  }, []);

  return (
    <>
      <MobileFooter
        absoluteUrl={absoluteUrl}
        languageSelect={languageSelect}
        isDoNotSellReady={isDoNotSellReady}
      />
      <DesktopFooter
        absoluteUrl={absoluteUrl}
        languageSelect={languageSelect}
        impressumQualifies={impressumQualifies}
        isDoNotSellReady={isDoNotSellReady}
      />
    </>
  );
}

export default StandardFooter;
